import { LazyImage } from '@components/common/image'
import { QUIZZES_IMAGE_PATH } from '@lib/constants/quizzes'

type Props = {
  children: React.ReactNode[] | React.ReactNode
}

const Layout = ({ children }: Props) => (
  <div
    className="relative min-h-screen overflow-hidden"
    style={{ backgroundColor: '#6f2c56' }}
  >
    <div className="opacity-50">
      <LazyImage
        path={`${QUIZZES_IMAGE_PATH}arena/`}
        alt="background shapes"
        className="absolute opacity-25 lg:hidden top-0"
        name="bg-shapes-top-sm"
      />
      <LazyImage
        path={`${QUIZZES_IMAGE_PATH}arena/`}
        alt="background shapes"
        className="absolute opacity-25 lg:hidden bottom-0"
        name="bg-shapes-bottom-sm"
      />
      <LazyImage
        path={`${QUIZZES_IMAGE_PATH}arena/`}
        alt="background shapes"
        className="absolute opacity-25 hidden w-1/2 lg:block bottom-0 left-0"
        name="bg-shapes-bottom-left-lg"
      />
      <LazyImage
        path={`${QUIZZES_IMAGE_PATH}arena/`}
        alt="background shapes"
        className="absolute opacity-25 hidden w-1/2 lg:block top-0 right-0"
        name="bg-shapes-top-right-lg"
      />
      <LazyImage
        path={`${QUIZZES_IMAGE_PATH}arena/`}
        alt="background shapes"
        className="absolute opacity-25 hidden w-1/2 lg:block right-0"
        name="bg-shapes-right-lg"
      />
      <LazyImage
        path={`${QUIZZES_IMAGE_PATH}arena/`}
        alt="background shapes"
        className="absolute opacity-25 hidden w-1/2 lg:block left-0 bottom-0"
        name="bg-shapes-left-lg"
      />
    </div>
    <div className="z-10 relative h-screen">{children}</div>
  </div>
)

export default Layout
